var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { OfficeAchievementGiftCodeResponseDto } from './office-achievement-gift-code.response.dto.js';
import { OfficeAchievementLevelResponseDto } from './office-achievement-level.response.dto.js';
export class OfficeAchievementResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    currentOfficeAchievementLevelId;
    currentOfficeAchievementLevel;
    officeAchievementLevels;
    officeAchievementGiftCode;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementResponseDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementResponseDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], OfficeAchievementResponseDto.prototype, "currentOfficeAchievementLevelId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    Type(() => OfficeAchievementLevelResponseDto),
    __metadata("design:type", Object)
], OfficeAchievementResponseDto.prototype, "currentOfficeAchievementLevel", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeAchievementLevelResponseDto),
    __metadata("design:type", Array)
], OfficeAchievementResponseDto.prototype, "officeAchievementLevels", void 0);
__decorate([
    Expose(),
    Type(() => OfficeAchievementGiftCodeResponseDto),
    __metadata("design:type", Object)
], OfficeAchievementResponseDto.prototype, "officeAchievementGiftCode", void 0);
//# sourceMappingURL=office-achievement.response.dto.js.map